module.exports = __webpack_public_path__ + "assets/Chevron-left.352c6478.svg";